import ErrorComponent from '@/components/ui/custom/ErrorComponent';
import PencilIcon from '@heroicons/react/24/solid/PencilIcon';
import { useTranslation } from 'react-i18next';

type NoPublishedScheduledLessonViewProps = {
  klassId: number;
};
export const NoPublishedScheduledLessonView = ({
  klassId,
}: NoPublishedScheduledLessonViewProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'manageScheduledLessonReport',
  });

  return (
    <div className="flex items-center justify-center size-full">
      <ErrorComponent
        actionButtons={[
          {
            icon: <PencilIcon />,
            text: t('goEditPage'),
            href: `/class/${klassId}/lessons`,
          },
        ]}
        errorTextTitle={t('cantEditReport')}
        errorTextSubTitle={t('publisInstructions')}
        hideStatusCode
        hideAnimation
        showBackButton={false}
      />
    </div>
  );
};
